import axios from 'axios';
import Auth from '../store/auth';

const API_URL = window.config.API_URL;
const BUILDER_ID = window.config.BUILDER_ID;

export function get(url, data) {

  if (!data) {
    data = {};
  }
  data.builder_id = BUILDER_ID;

  return axios({
    method: 'get',
    url: getUrl(url) + '?' + queryString(data),
    headers: {
      'Accept': 'application/json',
    }
  });
}

export function getInfo(url) {

  let data = {};
  data.builder_id = BUILDER_ID;
  return axios({
    method: 'get',
    url: url + BUILDER_ID,
    headers: {
      'Accept': 'application/json',
    }
  });
}

export function getTokenChat() {
  return axios({
    method: 'get',
    url: getUrl('chat-token/?builder_id=' + BUILDER_ID)
  });
}

export function post(url, data) {
  if (!data) {
    data = {};
  }
  data.builder_id = BUILDER_ID;
  return axios({
    method: 'post',
    url: getUrl(url),
    headers: {
      'Accept': 'application/json',
    },
    data: data
  });
}

export function login() {
  return axios({
    method: 'POST',
    url: getUrl('authentication'),
    data: {token: API_TOKEN},
    headers: {
      'Accept': 'application/json'
    }
  });
}

export function interceptors(cb) {
  axios.interceptors.response.use((res) => {
    return res;
  }, (err) => {
    cb(err);
    return Promise.reject(err)
  })
}

function getUrl(url) {
  return API_URL + url;
}

function queryString(obj) {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}



// WEBPACK FOOTER //
// ./src/helpers/api.js